import React from "react";
import cx from "classnames";

import type {TextCardData} from "../../types";
import H5 from "../typography/H5";

import styles from './TextCard.module.scss';
import List1 from "../typography/List1";

type TextCardProps = {
    card: TextCardData;
    className?: string;
    singleLineTitle?: boolean;
};

function TextCard({card, className, singleLineTitle}: TextCardProps) {

    return (
        <div className={cx(styles.card, className)}>
            <div className={styles.cardTopInfo}>
                <span className={styles.emoji}>{card.emoji}</span>
                <H5 sx={{
                    width: '100%',
                    '@media (max-width: 1199px)': {
                        minWidth: 0,
                    },
                    '@media (min-width: 576px) and (max-width: 767px)': {
                        overflowWrap: 'normal',
                        textWrap: 'wrap',
                    },
                    position: 'relative',
                    zIndex: 2,
                    whiteSpace: singleLineTitle ? 'nowrap' : undefined,
                }}>{card.title}</H5>
            </div>
            <List1 className={styles.description} sx={{
                width: '100%',
                position: 'relative',
                zIndex: 2,
            }}>
                {card.text}
            </List1>
        </div>
    );
}

export default TextCard
